import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const BusinessDetails = ({ form, setForm, onContinue, onBack, busy = false }) => {
  const [error, setError] = useState('');
  const submit = event => {
    event.preventDefault();
    if (busy) return;
    if (!form.business.trim()) { setError('Please enter your business name.'); return; }
    setError(''); onContinue();
  };
  return <>
    <h1 className="sr-heading" id="signup-review-title" tabIndex={-1} data-testid="signup-review-heading">A space for your business</h1>
    <p className="sr-subtitle" data-testid="signup-review-description">Make your Voxinity workspace your own.</p>
    <form onSubmit={submit} data-testid="signup-review-business-form">
      <div className="sr-field">
        <label htmlFor="signup-review-business">Business name</label>
        <Input id="signup-review-business" value={form.business} onChange={event => { setError(''); setForm(current => ({ ...current, business: event.target.value })); }} autoComplete="organization" placeholder="Your agency or business" maxLength={160} required disabled={busy} className="sr-input" data-testid="signup-review-business-input" />
      </div>
      {error && <p role="alert" className="sr-error" data-testid="signup-review-business-error">{error}</p>}
      <Button type="submit" className="sr-primary" disabled={busy} data-testid="signup-review-business-continue">{busy ? 'Saving…' : 'Continue'}<ArrowRight size={15} /></Button>
    </form>
    <Button variant="ghost" className="sr-back" disabled={busy} onClick={onBack} data-testid="signup-review-business-back"><ArrowLeft size={14} />Back</Button>
  </>;
};